import getWithToken from './base/get-with-token'

const getTenantConfig = id => getWithToken(`/tenants/${id}`)()

export default getTenantConfig